import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
interface Props {
  status?: 0 | 1 | 2;
}
export default function LineStep(props: Props) {
  const { status } = props;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "2px",
          backgroundColor:
            status === 0
              ? grey[300]
              : status === 1
              ? "secondary.main"
              : "success.main",
          height: "30px",
        }}
      ></Box>
    </Box>
  );
}
